module.exports = __webpack_public_path__ + "img/1_7.2cd18388.png";